export default __webpack_public_path__ + "static/media/PlanetText.34806f0c.png";